import { useResolvedCompanyCtx } from '@contexts/ResolvedCompanyContext/ResolvedCompanyProvider'
import { useLayoutIsXS } from '@segments/Responsive/client'
import * as React from 'react'

import { PromoHeaderText as SharedPromoHeaderText } from '~shared/components/Messages/PromoHeaderText'
import { TSingleSpace } from '~ui/styleGuide/spaces'

type TProps = NoChildren & {
  hasBorderBottom?: boolean
  bottomPadding?: TSingleSpace
}

/**
 * Promo header card used to highlight some important information set by the branch.
 */
export const PromoHeaderText: React.FC<TProps> = ({
  hasBorderBottom = false,
  bottomPadding = `none`,
}) => {
  const isMobile = useLayoutIsXS()

  const { resolvedBranch } = useResolvedCompanyCtx()

  const promoHeaderText = resolvedBranch.promoHeaderText

  if (!promoHeaderText) {
    return null
  }

  return (
    <SharedPromoHeaderText
      isMobile={isMobile}
      description={promoHeaderText}
      hasBorderBottom={hasBorderBottom}
      padding={
        isMobile
          ? { left: `medium`, right: `medium`, top: `smallMedium`, bottom: bottomPadding }
          : `none`
      }
    />
  )
}
